import { Flex, ModalBody, ModalFooter, ModalHeader } from '@chakra-ui/react'

import { Button } from '@/components/ui'

import { GridModalBody } from '../../components/GridModalBody'
import { GridModalDetails } from '../../components/GridModalDetails'
import { GridModalHeader } from '../../components/GridModalHeader'
import { scrollbarStyle } from '../../styles/styles'

interface GridEditingStepIProps {
  isNextDisabled?: boolean
  onClose: () => void
  onNext: () => void
}

export const GridEditingStep = ({
  isNextDisabled,
  onClose,
  onNext,
}: GridEditingStepIProps) => (
  <>
    <ModalHeader p={0} w='100%'>
      <GridModalHeader
        subtitle="Adjust the camera grids below in order to test the configuration's performance"
        title='Grid Configuration'
      />
    </ModalHeader>
    <ModalBody p={0} sx={scrollbarStyle}>
      <GridModalDetails />
      <GridModalBody hideActions onClose={onClose} />
    </ModalBody>
    <ModalFooter mt={6} p={0}>
      <Flex direction='row' gap={3} justifyContent='flex-end'>
        <Button mr={0} onClick={onClose} variant='secondary'>
          Cancel
        </Button>
        <Button isDisabled={isNextDisabled} onClick={onNext}>
          Test Grid
        </Button>
      </Flex>
    </ModalFooter>
  </>
)
